<template>
  <div class="nzm_video_wrap" v-if="info">
    <template v-if="info.config.bg_img">
      <img :src="info.config.bg_img" class="bg" @click="click_bg" />
      <div :style="wrap_style">
        <Video :info="video_props" />
      </div>
    </template>

    <template v-else>
      <Video :info="video_props" />
    </template>
  </div>
</template>
<script>
import { getJSON, getJSONP } from "../../api/myaxios";
import { toRem, urlToWebp } from "../../tools/tpl";
import click_handler from "../../tools/mgtv/click";
import { openLink } from "../../tools/mgtv/link";
import Video from "./NzmVideo/Video";

export default {
  name: "NzmVideo",
  components: {
    Video
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  data: function() {
    return {
      data_list: null
    };
  },
  methods: {
    click_bg() {
      click_handler(`${this.info.act_name_chn}-点击-背景`, () => {
        setTimeout(() => {
          openLink(this.info.config.bg_url);
        }, 200);
      });
    }
  },
  computed: {
    wrap_style: function() {
      if (!this.info.config) {
        return null;
      }
      if (this.info.config.bottom) {
        return {
          position: "absolute",
          bottom: toRem(this.info.config.bottom) || "0",
          left: ".75rem"
        };
      }
    },
    video_props: function() {
      let v_autoplay = false;
      if (this.info.config.v_autoplay === "0") {
        v_autoplay = false;
      } else if (this.info.config.v_autoplay === "1") {
        v_autoplay = $bus.device_info.net == 1; //aphone 1 iphone "1"
      } else if (this.info.config.v_autoplay === "2") {
        v_autoplay = true;
      }
      return {
        v_vid: this.info.config.video_id,
        v_poster: this.info.config.video_cover,
        v_autoplay,
        v_play_btn: "https://act.mgtv.com/h5/t21/assets/images/play.png"
      };
    }
  },
  mounted() {}
};
</script>


<style lang="stylus"  >
.nzm_video_wrap
    position relative 
    width 7.5rem
    .bg
      position relative
      display block
      width 100%
</style>
